<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/lightningDeals/add')"
    >
      新增活动
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="middle"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javastript:;" @click="del(operate)">删除活动</a>
        <a href="javastript:;" @click="push(operate)">信息推送</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import { bargainingList, delBargaining, mesPush } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "编号",
    dataIndex: "objId",
  },
  {
    title: "标题",
    dataIndex: "activityName",
  },
  {
    title: "状态",
    dataIndex: "statusDesc",
  },
  {
    title: "开始时间",
    dataIndex: "startTime",
    sorter: true,
  },
  {
    title: "结束时间",
    dataIndex: "endTime",
    sorter: true,
    scopedSlots: { customRender: "endTime" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    sorter: true,
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      activityName: "",
      endTiem: "",
      startTime: "",
      data: [],
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getBargainingList();
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      bargainingList({
        limit: 10,
        page: this.pagination.current,
        activityType: "spike",
      }).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    getBargainingList() {
      bargainingList({ limit: 10, page: 1, activityType: "spike" }).then(
        (res) => {
          this.pagination.total = res.count;
          this.data = res.data;
        }
      );
    },
    del(row) {
      this.loading = true;
      delBargaining(row.objId).then((res) => {
        this.loading = false;
        this.getBargainingList();
        message.success(res.data);
      });
    },
    push(row) {
      this.loading = true;
      mesPush(row.objId, 6).then((res) => {
        this.loading = false;
        message.success(res.data);
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/merchandising/lightningDeals/lightningDealsHome.vue